/**
 * Admin route component that requires admin role
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../shared/auth';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user } = useAuth();

  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
